<template>
  <div id="roomDetail">
    <Svge />
    <!-- <van-nav-bar title="房间详情" fixed placeholder left-text="返回" left-arrow>
      <a @click="$router.back()" slot="left">
        <i class="iconfont iconfanhuianniu"></i>
      </a>
    </van-nav-bar> -->
    <div class="content nowarp">
      <div class="inlineB">
        <p class="colorC l">当前状态</p>
        <p class="l">{{ roomStatusList[roomDetail.roomInfo.status - 1] }}</p>
      </div>
      <div class="inlineB">
        <p class="colorC l">下定状态</p>
        <p class="l">
          {{ statusReserveList[roomDetail.roomInfo.statusReserve - 1] }}
        </p>
      </div>
      <div class="inlineB">
        <p class="colorC l">归属管家</p>
        <p class="l">{{ roomDetail.belongName }}</p>
      </div>
    </div>
    <van-tabs v-model="active" class="tabs">
      <van-tab title="房间信息">
        <van-cell title="房间编码" :value="roomDetail.roomInfo.number" />
        <van-cell title="房间号" :value="roomDetail.roomInfo.no" />
        <van-cell title="出租价格" :value="roomDetail.roomInfo.price + '元'" />
        <van-cell title="面积" :value="roomDetail.roomInfo.acreage + '㎡'" />
        <van-cell
          title="是否多人间"
          :value="roomDetail.roomInfo.mrFlag == 1 ? '是' : '否'"
        />
        <van-cell
          title="是否带厨房"
          :value="roomDetail.roomInfo.kitchen == 1 ? '是' : '否'"
        />
        <van-cell
          title="是否独卫"
          :value="roomDetail.roomInfo.toilet == 1 ? '是' : '否'"
        />
        <van-cell
          title="是否有阳台"
          :value="roomDetail.roomInfo.balcony == 1 ? '是' : '否'"
        />
        <van-cell
          title="是否飘窗"
          :value="roomDetail.roomInfo.bayWindow == 1 ? '是' : '否'"
        />
        <van-cell
          title="是否优化间"
          :value="roomDetail.roomInfo.optimization == 1 ? '是' : '否'"
        />
        <van-cell title="创建时间" :value="roomDetail.roomInfo.createDate" />
        <van-cell title="创建人" :value="roomDetail.roomInfo.creatorName" />
        <div>
          <div class="title">房间照片&ensp;</div>
          <div class="imgBody">
            <div
              class="imgCard"
              v-for="(item, index) in roomDetail.roomInfo.roomImageList"
              :key="index"
            >
              <div
                class="img"
                @click="
                  imgShow = true;
                  imgIndex = index;
                  images = roomDetail.roomInfo.roomImageList;
                "
              >
                <van-image
                  width="2.8rem"
                  height="2.8rem"
                  :src="item.imageUrl"
                />
              </div>
            </div>
          </div>
        </div>
      </van-tab>
      <van-tab title="房源信息">
        <van-cell title="房源编码" :value="roomDetail.houseInfo.number" />
        <van-cell title="房源地址" :value="roomDetail.houseInfo.address" />
        <van-cell
          title="小区地址"
          :value="roomDetail.houseInfo.community.address"
        />
        <van-cell title="房东姓名" :value="roomDetail.propertyName" />
        <van-cell title="房东电话" class="space_bet">
            <template #right-icon>
              <a  class="tel" :href="'tel:'+roomDetail.propertyPhone">
               <van-icon name="phone" class="search-phone" color="#fd7e2d"  />
               拨打
            </a>
           
          </template>
        </van-cell>
        <van-cell
          title="收房合约租期"
          :value="
            roomDetail.propertyContractStartDate
              ? roomDetail.propertyContractStartDate +
                ' 到 ' +
                roomDetail.propertyContractEndDate
              : ''
          "
        />
        <van-cell
          title="户型"
          :value="
            (roomDetail.houseInfo.chamberNum || '-') +
            '室' +
            (roomDetail.houseInfo.hallNum || '-') +
            '厅' +
            (roomDetail.houseInfo.toiletNumber || '-') +
            '卫'
          "
        />
        <van-cell
          title="总面积"
          :value="roomDetail.houseInfo.totalAcreage + '㎡'"
        />
        <van-cell title="电户号" :value="roomDetail.houseInfo.electricCard" />
        <van-cell title="水户号" :value="roomDetail.houseInfo.waterCard" />
        <van-cell title="燃气户号" :value="roomDetail.houseInfo.gasCard" />
        <van-cell
          title="代缴电总度数"
          :value="roomDetail.houseInfo.electricTotal"
        />
        <van-cell
          title="代缴电峰度数"
          :value="roomDetail.houseInfo.electricMax"
        />
        <van-cell
          title="代缴电谷度数"
          :value="roomDetail.houseInfo.electricMin"
        />
        <van-cell title="代缴水度数" :value="roomDetail.houseInfo.water" />
        <van-cell title="代缴燃气度数" :value="roomDetail.houseInfo.gas" />
        <van-cell
          title="最新电总度数"
          :value="roomDetail.houseInfo.lastElectricTotal"
        />
        <van-cell
          title="最新电峰度数"
          :value="roomDetail.houseInfo.lastElectricMax"
        />
        <van-cell
          title="最新电谷度数"
          :value="roomDetail.houseInfo.lastElectricMin"
        />
        <van-cell title="最新水度数" :value="roomDetail.houseInfo.lastWater" />
        <van-cell title="最新燃气度数" :value="roomDetail.houseInfo.lastGas" />
        <van-cell title="创建时间" :value="roomDetail.houseInfo.createDate" />
        <van-cell title="创建人" :value="roomDetail.houseInfo.creatorName" />
        <div>
          <div class="title">房源照片&ensp;</div>
          <div class="imgBody">
            <div
              class="imgCard"
              v-for="(item, index) in roomDetail.houseInfo.pubImageList"
              :key="index"
            >
              <div
                class="img"
                @click="
                  imgShow = true;
                  imgIndex = index;
                  images = roomDetail.houseInfo.pubImageList;
                "
              >
                <van-image
                  width="2.8rem"
                  height="2.8rem"
                  :src="item.imageUrl"
                />
              </div>
            </div>
          </div>
        </div>
      </van-tab>
      <van-tab title="合约信息">
        <div class="body">
          <div
            class="card"
            v-for="(item, index) in roomDetail.contractList"
            :key="index"
            @click="
              $router.push({ path: '/contractDetail', query: { id: item.id } })
            "
          >
            <p>
              <span class="titlec">
                <span
                  :class="{ ellipsis: !item.showTitle }"
                  @click.stop="item.showTitle = !item.showTitle"
                  >{{ item.houseAddress }}</span
                >
                | {{ item.rentType == 1 ? "合租" : "整租" }}
              </span>
            </p>
            <p>
              <span>编码：{{ item.contractNumber }}</span>
              <span class="theme-color">{{
                contractList[item.status - 1]
              }}</span>
            </p>
            <p>
              <span
                >租客：{{ item.customerName }} </span
              >
              <!-- | {{ item.customerPhone }} -->
            </p>
            <p>
              <span>租期：{{ item.startDate }} 到 {{ item.endDate }}</span>
            </p>
            <p>
              <span>创建信息：{{ item.creator }} | {{ item.createDate }}</span>
              <span>{{ item.rental }}元/月</span>
            </p>
          </div>
        </div>
      </van-tab>
      <van-tab title="设备信息">
        <div class="lock">
          <van-tabs type="card" v-if="deviveData&& deviveData.length">
               <van-tab
                v-for="(item, index) in deviveData"
                :key="index"
                :label="item.roomName"
                :title="item.roomName"
              >
                <div class="deviceList" v-if="item.deviceList.length>0">
                  <div 
                    class="device active"
                   
                    v-for="(itm, index) in item.deviceList"
                    :key="index"
                    @click="goToDeviceDetail(itm)"
                  >
                  
                    <template v-if="item.deviceList.length>0">
                        <svg
                        width="50px"
                        height="70px"
                        fill="currentColor"
                        aria-hidden="true"
                        focusable="false"
                        class=""
                      >
                        <use
                          :xlink:href="'#' + svgSuccessList[itm.type - 1]"
                        ></use>
                      </svg>
                      <p>{{ deviceType[itm.type - 1] }}</p>
                      <!-- <h5 :class="[itm.online ? '' : 'active']">
                        {{ itm.sn }}
                      </h5> -->
                    </template>
                   
                    
                  </div>
                </div>
                  <div
                      v-else
                      style="
                        text-align: center;
                        color: #909399;
                        padding: 20px 0;
                      "
                    >
                      暂无数据
                    </div>
              </van-tab>
            <!-- <van-tab title="门锁信息">
              <van-tabs
                v-if="
                  roomDetail.roomInfo &&
                  roomDetail.roomInfo.doorlockList &&
                  roomDetail.roomInfo.doorlockList.length >= 1
                "
              >
                <van-tab title="基本信息">
                  <van-tabs type="card">
                    <van-tab
                      v-for="item in roomDetail.roomInfo.doorlockList"
                      :key="item.sn"
                      :title="item.areaNo"
                    >
                      <van-cell
                        title="门锁序列号"
                        :value="item.sn ? item.sn : '-'"
                      />
                      <van-cell
                        title="门锁电量"
                        :value="item.power ? item.power + '%' : '-'"
                      />
                      <van-cell
                        title="门锁状态"
                        :value="item.online ? '在线' : '离线'"
                      />
                      <van-cell
                        title="门锁型号"
                        :value="item.modelName ? item.modelName : '-'"
                      />
                      <van-cell
                        title="MAC地址"
                        :value="item.mac ? item.mac : '-'"
                      />
                      <van-cell
                        title="供应商"
                        :value="item.brand ? item.brand : '-'"
                      />
                      <van-cell
                        title="信号值"
                        :value="item.lqi ? item.lqi : '-'"
                      />
                    </van-tab>
                  </van-tabs>
                </van-tab>
                <van-tab title="发送密码记录">
                  <van-tabs type="card" v-if="lockListLength >= 1">
                    <van-tab
                      v-for="(item, index) in lockList"
                      :key="index"
                      :title="index"
                    >
                      <van-list
                        v-model="lockLoad"
                        :finished="lockFinished"
                        finished-text="没有更多了"
                        :immediate-check="false"
                        @load="getLockPage"
                      >
                        <div class="lockList">
                          <div
                            class="card"
                            v-for="(item1, index1) in item"
                            :key="index1"
                          >
                            <p>
                              <span class="lockBody-title">
                                {{ item1.startTime }}~{{ item1.endTime }}
                              </span>
                            </p>
                            <p>
                              <span
                                >密码类型：{{
                                  lockTypeList[item1.type - 1]
                                }}</span
                              >
                              <span class="theme-color"
                                >{{ lockOpList[item1.op - 1] }}｜{{
                                  lockResultList[item1.result - 1]
                                }}</span
                              >
                            </p>
                            <p>
                              <span>客户姓名：{{ item1.name }}</span>
                              <span>客户电话：{{ item1.phone }}</span>
                            </p>
                          </div>
                        </div>
                   
                      </van-list>
                    </van-tab>
                  </van-tabs>
                  <van-empty v-else description="暂无数据" />
                </van-tab>
                <van-tab title="其他">
                  <van-tabs type="card" v-if="lockListLength >= 1">
                    <van-tab
                      v-for="(item, index) in lockOtherList"
                      :key="index"
                      :title="index"
                    >
                      <div class="body">
                        <table>
                          <thead>
                            <tr>
                              <th>事件名称</th>
                              <th>事件内容</th>
                              <th>事件时间</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(tr, trx) in item || []" :key="trx">
                              <td class="min2">{{ tr.eventName }}</td>
                              <td class="min2">{{ tr.eventDetail }}</td>
                              <td class="min2">{{ tr.eventTime }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </van-tab>
                  </van-tabs>
                  <van-empty v-else description="暂无数据" />
                </van-tab>
              </van-tabs>
              <van-empty v-else description="暂无数据" />
            </van-tab>
            <van-tab title="电表信息">
              <van-tabs
                @click="eleChange"
                type="card"
                v-model="deviceName"
                v-if="
                  roomDetail.roomInfo &&
                  roomDetail.roomInfo.elemeterList &&
                  roomDetail.roomInfo.elemeterList.length >= 1
                "
              >
                <van-tab
                  :name="index"
                  v-for="(item, index) in roomDetail.roomInfo.elemeterList"
                  :key="item.sn"
                  :title="item.areaNo"
                >
                  <van-cell
                    title="电表序列号"
                    :value="item.sn ? item.sn : '-'"
                  />
                  <van-cell
                    title="电表名称"
                    :value="item.name ? item.name : '-'"
                  />
                  <van-cell
                    title="电表状态"
                    :value="item.online ? '在线' : '离线'"
                  />
                  <van-cell
                    title="电表型号"
                    :value="item.modelName ? item.modelName : '-'"
                  />
                  <van-cell title="uuid" :value="item.uuid ? item.uuid : '-'" />
                  <van-cell
                    title="最新抄表度数"
                    :value="item.electric ? item.electric : '-'"
                  />
                  <van-cell
                    title="最新抄表时间"
                    :value="item.eleReadDate ? item.eleReadDate : '-'"
                  />
                  <van-cell
                    title="绑定时间"
                    :value="item.bindTime ? item.bindTime : '-'"
                  />
                  <van-form
                    class="form"
                    style="margin: 20px 0; padding-bottom: 10px"
                    ref="formEle"
                    label-width="110px"
                    input-align="right"
                  >
                    <van-field name="抄表模式" label="抄表模式">
                      <template #input>
                        <van-radio-group
                          v-model="elemeterMode"
                          direction="horizontal"
                        >
                          <van-radio :name="1">自动</van-radio>

                          <van-radio :name="2">手动</van-radio>
                        </van-radio-group>
                      </template>
                    </van-field>
                    <div v-if="elemeterMode == 1"></div>
                    <div v-if="elemeterMode == 2">
                     

                      <div class="body">
                        <div class="picCard">
                          <van-uploader
                            :before-read="beforeRead"
                            :after-read="
                              (item) => {
                                elemeterUrl = [
                                  {
                                    url: upload_qiniu_addr + item.file.key,

                                    isImage: true,
                                  },
                                ];

                                $refs.formEle[0].resetValidation('elemeterUrl');
                              }
                            "
                            v-model="elemeterUrl"
                            :max-count="1"
                          />

                          <div class="text textBorder">
                            <van-field
                              type="number"
                              name="degree"
                              maxlength="11"
                              v-model="elemeterList[0].degree"
                              :placeholder="
                                '当前:' + houseDegrees.elemeterList.degree
                              "
                              :rules="[
                                { required: true, message: '请输入电表度数' },

                                {
                                  validator: validNum0Decimal2,

                                  message:
                                    '电表度数必须为正数或0，且最多保留两位小数',
                                },

                                {
                                  validator: (item) => {
                                    return !(
                                      elemeterList.degree <
                                      houseDegrees.elemeterList.degree
                                    );
                                  },

                                  message: `电表度数必须大于当前房源${houseDegrees.elemeterList.degree}`,
                                },

                                {
                                  validator: (item) => {
                                    return Boolean(elemeterUrl.length);
                                  },

                                  message: '请上传电表图',
                                },
                              ]"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <van-button
                      style="width: 70%; margin: 10px auto"
                      round
                      block
                      type="primary"
                      size="small"
                      @click="save(1, 'formEle')"
                      :loading="saveLoad"
                      >保存</van-button
                    >
                  </van-form>
                </van-tab>
              </van-tabs>

              <van-empty v-else description="暂无数据" />
            </van-tab>
            <van-tab name="3" title="水表信息">
              <van-tabs>
                <van-tab title="冷水表基本信息">
                  <van-tabs
                    @click="eleChange"
                    type="card"
                    v-model="deviceName"
                    v-if="
                      roomDetail.roomInfo &&
                      roomDetail.roomInfo.waterMeterColdList &&
                      roomDetail.roomInfo.waterMeterColdList.length >= 1
                    "
                  >
                    <van-tab
                      :name="index"
                      v-for="item in roomDetail.roomInfo.waterMeterColdList"
                      :key="item.sn"
                      :title="item.areaNo"
                    >
                      <van-cell
                        title="水表序列号"
                        :value="item.sn ? item.sn : '-'"
                      />
                      <van-cell
                        title="水表类型"
                        :value="item.meterType > 1 ? '热水表' : '冷水表'"
                      />
                      <van-cell
                        title="水表状态"
                        :value="item.online ? '在线' : '离线'"
                      />
                      <van-cell
                        title="水表型号"
                        :value="item.modelName ? item.modelName : '-'"
                      />

                      <van-cell
                        title="uuid"
                        :value="item.uuid ? item.uuid : '-'"
                      />
                      <van-cell
                        title="最新抄表度数"
                        :value="item.coldWater ? item.coldWater : '-'"
                      />

                      <van-cell
                        title="最新抄表时间"
                        :value="item.coldReadDate ? item.coldReadDate : '-'"
                      />
                      <van-cell
                        title="保修期开始"
                        :value="item.guaranteeBegin ? item.guaranteeBegin : '-'"
                      />
                      <van-cell
                        title="保修期结束"
                        :value="item.guaranteeEnd ? item.guaranteeEnd : '-'"
                      />
                      <van-form
                        class="form"
                        style="margin: 20px 0; padding-bottom: 10px"
                        ref="formColdWater"
                        label-width="110px"
                        input-align="right"
                      >
                        <van-field name="抄表模式" label="抄表模式">
                          <template #input>
                            <van-radio-group
                              v-model="coldWaterMode"
                              direction="horizontal"
                            >
                              <van-radio :name="1">自动</van-radio>

                              <van-radio :name="2">手动</van-radio>
                            </van-radio-group>
                          </template>
                        </van-field>
                        <div v-if="coldWaterMode == 1"></div>
                        <div v-if="coldWaterMode == 2">
                         

                          <div class="body">
                            <div class="picCard">
                              <van-uploader
                                :before-read="beforeRead"
                                :after-read="
                                  (item) => {
                                    coldWaterUrl = [
                                      {
                                        url: upload_qiniu_addr + item.file.key,

                                        isImage: true,
                                      },
                                    ];

                                    $refs.formColdWater[0].resetValidation(
                                      'coldWaterUrl'
                                    );
                                  }
                                "
                                v-model="coldWaterUrl"
                                :max-count="1"
                              />

                              <div class="text textBorder">
                                <van-field
                                  type="number"
                                  name="degree"
                                  maxlength="11"
                                  v-model="coldWaterList[0].degree"
                                  :placeholder="
                                    '当前:' + houseDegrees.coldWaterList.degree
                                  "
                                  :rules="[
                                    {
                                      required: true,
                                      message: '请输入冷水表度数',
                                    },

                                    {
                                      validator: validNum0Decimal2,

                                      message:
                                        '冷水表度数必须为正数或0，且最多保留两位小数',
                                    },

                                    {
                                      validator: (item) => {
                                        return !(
                                          coldWaterList.degree <
                                          houseDegrees.coldWaterList.degree
                                        );
                                      },

                                      message: `冷水表度数必须大于当前房源${houseDegrees.coldWaterList.degree}`,
                                    },

                                    {
                                      validator: (item) => {
                                        return Boolean(coldWaterUrl.length);
                                      },

                                      message: '请上传冷水表图',
                                    },
                                  ]"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <van-button
                          style="width: 70%; margin: 10px auto"
                          round
                          block
                          type="primary"
                          size="small"
                          @click="save(2, 'formColdWater')"
                          :loading="saveLoad"
                          >保存</van-button
                        >
                      </van-form>
                    </van-tab>
                  </van-tabs>
                  <van-empty v-else description="暂无数据" />
                </van-tab>

                <van-tab title="热水表基本信息">
                  <van-tabs
                    @click="eleChange"
                    type="card"
                    v-if="
                      roomDetail.roomInfo &&
                      roomDetail.roomInfo.waterMeterHotList &&
                      roomDetail.roomInfo.waterMeterHotList.length >= 1
                    "
                  >
                    <van-tab
                      v-for="item in roomDetail.roomInfo.waterMeterHotList"
                      :key="item.sn"
                      :title="item.areaNo"
                    >
                      <van-cell
                        title="水表序列号"
                        :value="item.sn ? item.sn : '-'"
                      />
                      <van-cell
                        title="水表类型"
                        :value="item.meterType > 1 ? '热水表' : '冷水表'"
                      />
                      <van-cell
                        title="水表状态"
                        :value="item.online ? '在线' : '离线'"
                      />
                      <van-cell
                        title="水表型号"
                        :value="item.modelName ? item.modelName : '-'"
                      />

                      <van-cell
                        title="uuid"
                        :value="item.uuid ? item.uuid : '-'"
                      />
                      <van-cell
                        title="最新抄表度数"
                        :value="item.hotWater ? item.hotWater : '-'"
                      />

                      <van-cell
                        title="最新抄表时间"
                        :value="item.hotReadDate ? item.hotReadDate : '-'"
                      />
                      <van-cell
                        title="保修期开始"
                        :value="item.guaranteeBegin ? item.guaranteeBegin : '-'"
                      />
                      <van-cell
                        title="保修期结束"
                        :value="item.guaranteeEnd ? item.guaranteeEnd : '-'"
                      />
                      <van-form
                        class="form"
                        style="margin: 20px 0; padding-bottom: 10px"
                        ref="formHotWater"
                        label-width="110px"
                        input-align="right"
                      >
                        <van-field name="抄表模式" label="抄表模式">
                          <template #input>
                            <van-radio-group
                              v-model="hotWaterMode"
                              direction="horizontal"
                            >
                              <van-radio :name="1">自动</van-radio>

                              <van-radio :name="2">手动</van-radio>
                            </van-radio-group>
                          </template>
                        </van-field>
                        <div v-if="hotWaterMode == 1"></div>
                        <div v-if="hotWaterMode == 2">
                     

                          <div class="body">
                            <div class="picCard">
                              <van-uploader
                                :before-read="beforeRead"
                                :after-read="
                                  (item) => {
                                    hotWaterUrl = [
                                      {
                                        url: upload_qiniu_addr + item.file.key,

                                        isImage: true,
                                      },
                                    ];

                                    $refs.formHotWater[0].resetValidation(
                                      'hotWaterUrl'
                                    );
                                  }
                                "
                                v-model="hotWaterUrl"
                                :max-count="1"
                              />

                              <div class="text textBorder">
                                <van-field
                                  type="number"
                                  name="degree"
                                  maxlength="11"
                                  v-model="hotWaterList[0].degree"
                                  :placeholder="
                                    '当前:' + houseDegrees.hotWaterList.degree
                                  "
                                  :rules="[
                                    {
                                      required: true,
                                      message: '请输入冷水表度数',
                                    },

                                    {
                                      validator: validNum0Decimal2,

                                      message:
                                        '冷水表度数必须为正数或0，且最多保留两位小数',
                                    },

                                    {
                                      validator: (item) => {
                                        return !(
                                          hotWaterList.degree <
                                          houseDegrees.hotWaterList.degree
                                        );
                                      },

                                      message: `冷水表度数必须大于当前房源${houseDegrees.hotWaterList.degree}`,
                                    },

                                    {
                                      validator: (item) => {
                                        return Boolean(hotWaterUrl.length);
                                      },

                                      message: '请上传冷水表图',
                                    },
                                  ]"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <van-button
                          style="width: 70%; margin: 10px auto"
                          round
                          block
                          type="primary"
                          size="small"
                          @click="save(3, 'formHotWater')"
                          :loading="saveLoad"
                          >保存</van-button
                        >
                      </van-form>
                    </van-tab>
                  </van-tabs>
                  <van-empty v-else description="暂无数据" />
                </van-tab>
              </van-tabs>
            </van-tab> -->
          </van-tabs>
            <van-empty v-else description="暂无数据" />
        </div>
      </van-tab>
      <div
        v-if="
          (roomDetail.roomInfo.status == 6 &&
            roomDetail.roomInfo.statusReserve == 1) ||
          ((roomDetail.roomInfo.status == 5 ||
            roomDetail.roomInfo.status == 6) &&
            roomDetail.roomInfo.statusReserve == 1)
        "
        style="height: 1.2rem"
      ></div>
    </van-tabs>
    <div class="btn">
      <van-button
        v-if="
          (roomDetail.roomInfo.status == 5 ||
            roomDetail.roomInfo.status == 6) &&
          roomDetail.roomInfo.statusReserve == 1 &&
          $store.state.buttonAuth.indexOf('crm_roomContract') > -1
        "
        class="font3"
        type="primary"
        @click="
          $router.push({
            path: 'contractAdd',
            query: {
              houseId: roomDetail.houseInfo.id,
              ownerType: roomDetail.houseInfo.ownerType,
              roomNo:
                roomDetail.houseInfo.type == 1 ? roomDetail.roomInfo.no : null,
            },
          })
        "
        >签约</van-button
      >
      <van-button
        v-if="
          (roomDetail.roomInfo.status == 5 ||
            roomDetail.roomInfo.status == 6) &&
          roomDetail.roomInfo.statusReserve == 1 &&
          $store.state.buttonAuth.indexOf('crm_roomDestine') > -1
        "
        class="font3"
        type="primary"
        @click="
          $router.push({
            path: 'destineAdd',
            query: {
              houseId: roomDetail.houseInfo.id,
              roomNo:
                roomDetail.houseInfo.type == 1 ? roomDetail.roomInfo.no : null,
            },
          })
        "
        >下定</van-button
      >
      <van-button
        v-if="
          $store.state.buttonAuth.indexOf('crm_roomSendLock') > -1 &&
          roomDetail.sendPasswordShow &&
          roomDetail.roomInfo.status != 10
        "
        type="primary"
        @click="sendLock"
        >发送密码</van-button
      >
    </div>
    <van-image-preview
      v-model="imgShow"
      :startPosition="imgIndex"
      :images="images"
    ></van-image-preview>
    <!-- 发送密码 -->
    <van-dialog
      v-model="showSendLock"
      title="发送密码"
      show-cancel-button
      :before-close="saveLock"
      class="sendLock"
    >
      <van-form ref="lockForm" input-align="right">
        <van-field required name="type" label="密码类型">
          <template #input>
            <van-radio-group v-model="lockQuery.type" direction="horizontal">
              <van-radio :name="1">临时密码</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <!-- <van-field
          required
          v-model="lockQuery.phone"
          type="tel"
          name="phone"
          label="手机号"
          placeholder="点击填写"
          maxlength="11"
          :rules="[
            { required: true, message: '请填写手机号' },
            { validator: validPhone, message: '请输入正确手机号' },
          ]"
        /> -->
       
      </van-form>
    </van-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Svge from "@/components/svge";
import { compress, compressAccurately } from "image-conversion";
import {
  requestRoomDetail,
  requestPCStore,
  requestLockPassword,
  requestLockKeytime,
  requestLockInfo,
  requestLockRefresh,
  requestLocklist,
  requestOtherLocklist,
  requestDeviceList,
  requestQiniuToken,
  requestGoSettlement,
  requestUpdateDevice,
  requsetDeviceListDetail
} from "@/api";
import request from "@/utils/request";
import { mergeRowCol, accSub, formatDate, parseTime } from "@/utils/index";
import { validPhone, validNum0Decimal2 } from "@/utils/validate";
export default {
  name: "roomDetail",
  components: {
    Svge,
  },
  data() {
    return {
      active: 0,
      roomDetail: {
        roomInfo: {},
        houseInfo: {
          community: {},
        },
      },
      imgShow: false,
      imgIndex: 0,
      images: [
        "https://img.yzcdn.cn/vant/cat.jpeg",
        "http://img.room1000.com/158720028069720190603_180205.jpg",
        "http://img.room1000.com/158720027022420190604_124330.jpg",
        "http://img.room1000.com/158720030539720190603_141228.jpg",
      ],
      //发送密码
      showSendLock: false,
      lockLoad: false,
      lockFinished: false,
      lockInfo: {},
      lockQuery: {
        type: 1,
        phone: "",
        houseId: "",
      },
      saveLoadLock: false,
        deviceLoading: false,
      deviveData:[],
      lockPageQuery: {
        houseId: "",
        roomId: "",
        contractId: "",
        pageNumber: 1,
        pageSize: 10,
      },
      lockList: [],
      lockListLength: 0,
      lockOtherList: [],
      lockOtherListLength: 0,
      // deviceQuery: {
      //   type: 1,
      //   deviceList: [],
      // },
      elemeterMode: 1,
      coldWaterMode: 1,
      hotWaterMode: 1,
      imageUrl: "",
      elemeterList: [],
      coldWaterList: [],
      hotWaterList: [],
      elemeterUrl: [],
      coldWaterUrl: [],
      hotWaterUrl: [],
      houseDegrees: {
        elemeterList: [],
        coldWaterList: [],
        hotWaterList: [],
      },
      qiniuData: {
        key: "",

        token: "",
      },
      deviceTypes: ["电表", "冷水表", "热水表"],
      saveLoad: false,
      deviceName: 0,
    };
  },
  computed: {
    ...mapState([
      "idTypeList",
      "destineList",
      "payList",
      "contractList",
      "customerList",
      "contactList",
      "roomStatusList",
      "statusReserveList",
      "lockTypeList",
      "lockStatusList",
      "lockResultList",
      "lockOpList",
      "upload_qiniu_addr",
       "deviceTypeIcon",
      "deviceType",
      "svgSuccessList",
      "svgFailList",
    ]),
  },
  created() {
    this.getDetail();
  },
  mounted() {
    this.getQiniuToken();
  },
  methods: {
    getDetail() {
      const toast1 = this.$toast.loading({
        forbidClick: true,
        duration: 0,
        message: "加载中...",
      });
      requestRoomDetail(this.$route.query.id)
        .then((res) => {
          res.data.contractList.forEach((d) => {
            d.showTitle = false;
          });
          this.roomDetail = res.data;
          this.lockPageQuery.houseId = this.roomDetail.houseInfo.id;
          this.lockPageQuery.roomId = this.roomDetail.id;
          this.getLockPage();
          this.getLockAsyncList();
          this.getDeviceListDetail()
          // this.getDeviceList(this.roomDetail.houseInfo.id); 
          toast1.clear();
        })
        .catch((err) => {
          toast1.clear();
        });
    },
    //门店下拉
    getPCStore() {
      requestPCStore().then((res) => {
        res.data.forEach((d) => {
          d.text = d.name;
          d.value = d.id;
        });
        this.storeList = res.data;
      });
    },
     getDeviceListDetail() {
      this.deviceLoading = true;
 
      requsetDeviceListDetail(this.lockPageQuery)
        .then((res) => {
          console.log(res);
          this.deviceLoading = false;
          this.deviveData = res.data
        })
        .catch((err) => {
          this.deviceLoading = false;
          console.log(err);
        });
    },
    // 查询门锁异步消息记录
    getLockAsyncList() {
      requestOtherLocklist({
        houseId: this.roomDetail.houseInfo.id,
        roomId: this.roomDetail.id,
      }).then((res) => {
        console.log(res);
        this.lockOtherListLength = Object.keys(res.data).length;
        this.lockOtherList = res.data;
      });
    },
    goToDeviceDetail(row){
      this.$router.push({path:'/deviceDetail',query:{id:row.id}})
    },  
    //密码记录
    getLockPage() {
      requestLocklist(this.lockPageQuery)
        .then((res) => {
          console.log("wqewq", res);
          this.lockListLength = Object.keys(res.data).length;
          this.lockList = res.data;
          //   if (this.lockFinished) return;
          //   this.lockList = [...this.lockList, ...res.data];
          //   let prePage = accSub(res.data.pages, 1);
          //   this.lockLoad = false;
          //   this.lockPageQuery.pageNumber++;
          //   if (
          //     (res.data.pages == res.data.current &&
          //       res.data.length ==
          //         accSub(res.data.total, prePage * 10)) ||
          //     !res.data.length
          //   ) {
          //     this.lockFinished = true;
          //   }
        })
        .catch((err) => {
          this.lockLoad = false;
          this.lockFinished = true;
        });
    },
    //发送密码
    sendLock() {
      this.showSendLock = true;
      this.lockQuery.houseId = this.roomDetail.houseInfo.id;
      const toast1 = this.$toast.loading({
        forbidClick: true,
        duration: 0,
        message: "加载中...",
      });
      requestLockInfo(this.roomDetail.houseInfo.id)
        .then((res) => {
          this.lockInfo = res.data || {};
          toast1.clear();
        })
        .catch((err) => {
          toast1.clear();
        });
    },
    //门锁刷新
    refreshLock() {
      const toast1 = this.$toast.loading({
        forbidClick: true,
        duration: 0,
        message: "加载中...",
      });
      requestLockRefresh(this.lockQuery.houseId)
        .then((res) => {
          this.lockInfo = res.data || {};
          toast1.clear();
        })
        .catch((err) => {
          toast1.clear();
        });
    },
    saveLock(action, done) {
      if (action === "confirm") {
        this.$refs.lockForm
          .validate()
          .then((valid) => {
            //临时密码
            let param = {
              phone: this.lockQuery.phone,
              houseId: this.lockQuery.houseId,
              type: 1,
              roomId: this.roomDetail.id,
            };
            requestLockPassword(param)
              .then((res) => {
                done();
                this.$toast({
                  type: "success",
                  message: "发送成功!",
                  overlay: true,
                  closeOnClickOverlay: true,
                  onClose: () => {
                    this.getDetail();
                    this.lockLoad = false;
                    this.lockFinished = false;
                    this.lockPageQuery.pageNumber = 1;
                    this.lockList = [];
                    this.getLockPage();
                  },
                });
                this.showSendLock = false;
              })
              .catch((err) => {
                done(false);
              });
          })
          .catch((err) => {
            done(false);
          });
      } else {
        done();
        this.resetLock();
      }
    },
    resetLock() {
      this.lockInfo = {};
      this.lockQuery = {
        type: 1,
        phone: "",
        houseId: "",
      };
    },
    eleChange(name, title) {
      console.log(name, title);
      if (name > 0) {
        this.getDeviceList(this.roomDetail.id);
      } else {
        this.getDeviceList(this.roomDetail.houseInfo.id);
      }
    },

    getDeviceList(id) {
      requestDeviceList(id)
        .then((res) => {
          console.log(res);
          if (res) {
            let elemeterList = res.data.filter((item) => {
              return item.deviceType == 1;
            });
            let coldWaterList = res.data.filter((item) => {
              return item.deviceType == 2;
            });
            let hotWaterList = res.data.filter((item) => {
              return item.deviceType == 3;
            });

            this.elemeterList = elemeterList || [];
            this.coldWaterList = coldWaterList || [];
            this.hotWaterList = hotWaterList || [];
            if (this.elemeterList && this.elemeterList.length) {
              this.elemeterUrl = this.elemeterList[0].imageUrl
                ? [
                    {
                      url: this.elemeterList[0].imageUrl,
                      isImage: true,
                    },
                  ]
                : [];
            }

            if (this.coldWaterList && this.coldWaterList.length) {
              this.coldWaterUrl = this.coldWaterList[0].imageUrl
                ? [
                    {
                      url: this.coldWaterList[0].imageUrl,
                      isImage: true,
                    },
                  ]
                : [];
            }

            if (this.hotWaterList && this.hotWaterList.length) {
              this.hotWaterUrl = this.hotWaterList[0].imageUrl
                ? [
                    {
                      url: this.hotWaterList[0].imageUrl,
                      isImage: true,
                    },
                  ]
                : [];
            }

            this.houseDegrees.elemeterList = this._.cloneDeep(
              this.elemeterList[0]
            );
            this.houseDegrees.coldWaterList = this._.cloneDeep(
              this.coldWaterList[0]
            );
            this.houseDegrees.hotWaterList = this._.cloneDeep(
              this.hotWaterList[0]
            );
            this.houseDegrees.elemeterList.degree =
              this.houseDegrees.elemeterList.degree / 1;
            this.houseDegrees.coldWaterList.degree =
              this.houseDegrees.coldWaterList.degree / 1;
            this.houseDegrees.hotWaterList.degree =
              this.houseDegrees.hotWaterList.degree / 1;

            console.log(this.houseDegrees);
          }
          this.deviceLoad = false;
        })
        .catch((err) => {
          this.deviceLoad = false;
        });
    },
    //图片上传前校验，压缩

    beforeRead(file) {
      const isJPG = file.type === "image/jpeg";

      const isPNG = file.type === "image/png";

      const isLt2M = file.size / 1024 / 1024 < 2;

      const isLt8M = file.size / 1024 / 1024 < 8;

      const isLt10M = file.size / 1024 / 1024 < 10;

      if (!isJPG && !isPNG) {
        this.$toast.fail("图片只能是 JPG/PNG 格式！");

        return false;
      }

      if (!isLt10M) {
        this.$toast.fail("图片大小不能超过 10MB!");

        return false;
      }

      this.qiniuData.key = Date.now() + file.name;

      return new Promise((resolve, reject) => {
        compressAccurately(file, 400).then((fileMin) => {
          let data = new FormData();

          data.append("token", this.qiniuData.token);

          data.append("key", this.qiniuData.key);

          data.append("file", fileMin);

          request({
            url: this.$store.state.qiniuUpload,

            method: "post",

            processData: false,

            headers: {
              "Content-Type": "multipart/form-data",
            },

            data: data,
          })
            .then((res) => {
              let newFile = fileMin;

              newFile.key = res.key;

              resolve(newFile);
            })

            .catch((err) => {
              console.log(err);

              reject(err);
            });
        });
      });
    },
    async save(type, formName) {
      console.log(this.$refs);
      this.$refs[formName][0].validate().then((valid) => {
        if (type == 1) {
          console.log(this.elemeterUrl.url);
          this.elemeterList[0].imageUrl = this.elemeterUrl[0].url;
          this.uploadDevice(this.elemeterMode, this.elemeterList);
        } else if (type == 2) {
          this.coldWaterList[0].imageUrl = this.coldWaterUrl[0].url;
          this.uploadDevice(this.coldWaterMode, this.coldWaterList);
        } else {
          this.hotWaterList[0].imageUrl = this.hotWaterUrl[0].url;
          this.uploadDevice(this.hotWaterMode, this.hotWaterList);
        }
      });
    },
    uploadDevice(mode, data) {
      console.log(data);
      if (mode == 1) {
        this.saveLoad = true;
        requestGoSettlement(data[0].busniessId)
          .then((res) => {
            console.log(res);

            if (res) {
              this.$toast.success({
                message: "自动抄表操作成功!",
              });
              this.saveLoad = false;
            }
          })
          .catch((err) => {});
      } else {
        this.saveLoad = true;
        requestUpdateDevice(data)
          .then((res) => {
            console.log(res);

            if (res) {
              this.$toast.success({
                message: "手动抄表操作成功!",
              });
              this.saveLoad = false;
            }
          })
          .catch((err) => {});
      }
    },
    //获取七牛token

    getQiniuToken() {
      requestQiniuToken()
        .then((res) => {
          this.qiniuData.token = res.data;
        })

        .catch((err) => {
          console.log(err);
        });
    },
    validPhone(val) {
      return validPhone(val);
    },
    //正数或0，最多保留两位小数

    validNum0Decimal2(val) {
      return validNum0Decimal2(val);
    },
  },
  watch: {},
};
</script>
<style lang="scss" scoped>
@import "../common/scss/variable.scss";
#roomDetail {
  .colorC {
    color: $colorC;
  }
  .titlee {
    padding: 0.2rem 0;
    background-color: #fff;
    font-size: 0.3rem;
  }
  .content {
    background-color: #fff;
    display: flex;
    // border-radius: 0.2rem;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    &.nowarp {
      flex-wrap: nowrap;
    }
    .inlineB {
      flex: 1;
      padding: 0.2rem 0;
      width: 33.3%;
      min-width: 33.3%;
      max-width: 33.3%;
      p.l {
        line-height: 0.7rem;
        height: 0.7rem;
      }
    }
  }
  .tabs {
    /deep/.van-tabs__wrap {
      margin: 0.2rem 0;
    }
    /deep/.van-tabs__content {
      height: calc(100vh - 3.6rem);
      overflow: scroll;
    }
    /deep/ .lock .van-tabs__content {
      height: calc(100vh - 6rem);
      overflow: scroll;
    }
    /deep/.van-tabs__nav--card {
      border: 0.02667rem solid #fd7e2d;
    }
    /deep/.van-tabs__nav--card .van-tab.van-tab--active {
      background-color: #fd7e2d;
      color: #fff;
    }
    /deep/.van-tabs__nav--card .van-tab {
      color: #333;
      border-right: 0.02667rem solid #fd7e2d;
    }
    /deep/.van-tabs__nav--card .van-tab:last-child {
      border-right: none;
    }
    .van-steps {
      text-align: left;
      padding-left: 2rem;
      /deep/.van-step__title {
        padding-left: 0.3rem;
        p {
          padding-top: 0.2rem;
        }
      }
    }
    .body {
      width: 100%;
      overflow-x: auto;
      table {
        min-width: 100%;
        width: auto;
        text-align: center;
        border-left: 1px solid #ebeef5;
        border-top: 1px solid #ebeef5;
        tr {
          td,
          th {
            border-right: 1px solid #ebeef5;
            border-bottom: 1px solid #ebeef5;
          }
          td {
            background: #fff;
          }
        }
        tr > th:first-child,
        tr > td:first-child {
          position: sticky;
          position: -webkit-sticky;
          left: 0;
          z-index: 10;
          text-align: left;
        }
        thead {
          tr {
            background-color: #f3f9ff;
            th {
              // position: sticky;
              // position: -webkit-sticky;
              // top: 0;
              background-color: #f3f9ff;
            }
          }
        }
        .active {
          background: #e6f2fd;
          td {
            background: #e6f2fd;
          }
        }
      }
    }
    .body {
      // padding-top: 0.001rem;
      font-size: 0.35rem;
      // margin-top: 0.3rem;
      .card {
        background: #fff;
        margin: 0.3rem;
        border-radius: 0.2rem;
        color: $color9;
        padding: 0.2rem 0;
        // margin: 0.2rem 0;
        p {
          text-align: left;
          display: flex;
          justify-content: space-between;
          padding: 0 0.4rem;
          line-height: 0.8rem;
          // height: 0.8rem;
          .titlec {
            font-size: 0.35rem;
            font-weight: 600;
            color: #000;
            // span {
            //     max-width: 4.5rem;
            //     vertical-align: top;
            //     overflow: hidden;
            //     display: inline-block;
            //     height: auto;
            //     text-overflow: ellipsis;
            // }
            // .ellipsis {
            //     white-space: nowrap;
            // }
          }
          .big {
            font-size: 0.5rem;
          }
        }
      }
      > .card:first-child {
        margin-top: 0;
      }
      .theme-color {
        color: $theme-color;
      }
    }
    .title {
      text-align: left;
      padding: 0.3rem 0.2rem;
      font-weight: 600;
      font-size: 0.37rem;
    }
    .imgBody {
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      background-color: #fff;
      padding: 0 0.2rem 0.2rem 0.2rem;
      border-radius: 0.2rem;
      .imgCard {
        padding: 0.2rem;
        .text {
          line-height: 0.8rem;
        }
      }
    }
    .lockList {
      // padding-top: 0.001rem;
      font-size: 0.35rem;
      // margin-top: 0.3rem;
      .card {
        background: #fff;
        margin-bottom: 0.3rem;
        // border-radius: 0.2rem;
        color: $color9;
        padding: 0.2rem 0;
        // margin: 0.2rem 0;
        p {
          text-align: left;
          display: flex;
          justify-content: space-between;
          padding: 0 0.4rem;
          line-height: 0.8rem;
          > span {
            height: 0.8rem;
          }
          .lockBody-title {
            font-size: 0.35rem;
            font-weight: 600;
            height: auto;
            color: #000;
            // span {
            //     max-width: 4.5rem;
            //     vertical-align: top;
            //     overflow: hidden;
            //     display: inline-block;
            //     height: auto;
            //     text-overflow: ellipsis;
            // }
            // .ellipsis {
            //     white-space: nowrap;
            // }
          }
          .big {
            font-size: 0.4rem;
          }
        }
      }

      > .card:first-child {
        margin-top: 0;
      }
      .theme-color {
        color: $theme-color;
      }
    }
  }
  .btn {
    width: 100%;
    z-index: 8848;
    position: fixed;
    bottom: 0;
    left: 0;
    border-radius: 0.1rem;
    overflow: hidden;
    display: flex;
    /deep/.van-button {
      margin-left: -1px;
      border: none;
      border-radius: 0;
      flex: 1;
      &:not(:last-child)::after {
        height: 50%;
        position: absolute;
        box-sizing: border-box;
        content: " ";
        pointer-events: none;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        border-right: 0.02667rem solid #ebedf0;
        z-index: 99;
      }
    }
    a {
      color: #fff;
    }
  }
}
.success {
  color: $success-color;
  .van-button {
    border-radius: 1rem;
    transform: translateY(-0.1rem);
  }
}
.fail {
  color: $fail-color;
  .van-button {
    border-radius: 1rem;
    transform: translateY(-0.1rem);
  }
}
.field {
  padding: 0.26667rem 0.42667rem;

  background: #fff;

  font-size: 0.3rem;

  line-height: 0.64rem;

  color: #323232;

  text-align: left;

  border-top: 1px solid #ebedf0;

  border-bottom: 1px solid #ebedf0;

  .button-mini {
    width: 0.5rem;

    height: 0.5rem;

    line-height: 0.5rem;

    display: inline-block;

    text-align: center;

    border: 1px solid #a2a2a2;

    border-radius: 0.1rem;

    vertical-align: middle;
  }
}
.form {
  background-color: #fff;

  text-align: left;

  /deep/.van-field__error-message {
    text-align: center;
  }

  .field {
    position: relative;
  }

  .body {
    padding: 0.1rem;

    .van-uploader {
      // margin: 0.2rem;

      /deep/.van-uploader__preview-image {
        border: 1px solid #ebedf0;
      }
    }

    .picCard {
      display: inline-block;

      margin: 0.2rem;

      width: 2.2rem;

      .text {
        text-align: center;

        .van-field {
          padding: 0;

          /deep/input {
            text-align: center;
          }
        }
      }

      .textBorder {
        /deep/.van-field__body {
          border: 1px solid $border-color;

          border-radius: 0.1rem;

          overflow: hidden;
        }
      }
    }
  }

  .body1 {
    padding: 0.3rem;
  }
}
.deviceList {
  padding:0 20px 20px 20px;
  display: flex;
   flex-wrap: wrap;
  .device {
    width: 50%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    // margin-bottom:20px;
    .iconfont {
      margin: 20px 0 10px 0;
      font-size: 64px;
      &.active {
        color: #cccccc;
      }
    }
    &.active {
        cursor: pointer;
    }
    p {
      font-size: 12px;
      color: #05BAC5;;
      margin-bottom: 15px;
      &.active{
         color: #cccccc;
      }
    }
    h5 {
        color: #05BAC5;
      &.active {
        color: #cccccc;
      }
    }
  }
}
</style>
